import React from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  Stack,
  IconButton,
  Divider,
  Link,
} from "@mui/material";
import { LinkedIn, Instagram, Email, Favorite } from "@mui/icons-material";

const footerLinks = {
  produto: {
    title: "Produto",
    links: [
      { label: "Dashboard", href: "#" },
      { label: "Metas", href: "#" },
      { label: "Análise SWOT", href: "#" },
      { label: "ThinkBoard", href: "#" },
      { label: "Insights IA", href: "#" },
      { label: "Mapa Estratégico", href: "#" },
    ],
  },
  recursos: {
    title: "Recursos",
    links: [
      { label: "Central de Ajuda", href: "#" },
      { label: "Tutoriais em Vídeo", href: "#video-section" },
      { label: "Blog", href: "#" },
      { label: "Webinars", href: "#" },
    ],
  },
  empresa: {
    title: "Empresa",
    links: [
      { label: "Sobre Nós", href: "#" },
      { label: "Contato", href: "mailto:thinkway.app@gmail.com" },
      { label: "Carreiras", href: "#" },
      { label: "Parceiros", href: "#" },
    ],
  },
  legal: {
    title: "Legal",
    links: [
      { label: "Termos de Uso", href: "#" },
      { label: "Política de Privacidade", href: "#" },
      { label: "LGPD", href: "#" },
      { label: "Cookies", href: "#" },
    ],
  },
};

const socialLinks = [
  {
    icon: <LinkedIn />,
    href: "https://www.linkedin.com/company/think-way-planejamento-estrategico/posts/?feedView=all",
    label: "LinkedIn",
  },
  {
    icon: <Instagram />,
    href: "https://www.instagram.com/thinkway.app/",
    label: "Instagram",
  },
  {
    icon: <Email />,
    href: "mailto:thinkway.app@gmail.com",
    label: "Email",
  },
];

const FooterSection: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      id="footer"
      component="footer"
      sx={{
        backgroundColor: "#042E4B",
        color: "white",
        pt: { xs: 8, md: 10 },
        pb: 4,
      }}
    >
      <Container maxWidth="lg">
        {/* Main Footer Content */}
        <Grid container spacing={4} sx={{ mb: 6 }}>
          {/* Brand Column */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Stack spacing={3}>
              <Stack direction="row" alignItems="center" spacing={1.5}>
                <Box
                  component="img"
                  src="/logo512teste.png"
                  alt="Logo ThinkWay"
                  sx={{ height: 48 }}
                />
                <Typography
                  variant="h5"
                  sx={{
                    fontWeight: 700,
                    color: "white",
                  }}
                >
                  ThinkWay
                </Typography>
              </Stack>

              <Typography
                variant="body2"
                sx={{
                  color: "rgba(255,255,255,0.7)",
                  lineHeight: 1.7,
                  maxWidth: 300,
                }}
              >
                Transforme o planejamento estratégico da sua empresa com
                inteligência artificial. Defina metas, acompanhe resultados e
                alcance o sucesso.
              </Typography>

              {/* Social Links */}
              <Stack direction="row" spacing={1}>
                {socialLinks.map((social) => (
                  <IconButton
                    key={social.label}
                    component="a"
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={social.label}
                    sx={{
                      color: "rgba(255,255,255,0.7)",
                      backgroundColor: "rgba(255,255,255,0.1)",
                      "&:hover": {
                        backgroundColor: "#EF443C",
                        color: "white",
                      },
                      transition: "all 0.2s ease",
                    }}
                  >
                    {social.icon}
                  </IconButton>
                ))}
              </Stack>
            </Stack>
          </Grid>

          {/* Links Columns */}
          <Grid size={{ xs: 12, md: 8 }}>
            <Grid container spacing={3}>
              {Object.values(footerLinks).map((section) => (
                <Grid size={{ xs: 6, sm: 3 }} key={section.title}>
                  <Typography
                    variant="subtitle2"
                    sx={{
                      fontWeight: 700,
                      color: "white",
                      mb: 2,
                      textTransform: "uppercase",
                      letterSpacing: 1,
                      fontSize: "0.75rem",
                    }}
                  >
                    {section.title}
                  </Typography>
                  <Stack spacing={1.5}>
                    {section.links.map((link) => (
                      <Link
                        key={link.label}
                        href={link.href}
                        sx={{
                          color: "rgba(255,255,255,0.7)",
                          textDecoration: "none",
                          fontSize: "0.875rem",
                          transition: "color 0.2s ease",
                          "&:hover": {
                            color: "#EF443C",
                          },
                        }}
                      >
                        {link.label}
                      </Link>
                    ))}
                  </Stack>
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: "rgba(255,255,255,0.1)", mb: 4 }} />

        {/* Bottom Bar */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Typography
            variant="body2"
            sx={{
              color: "rgba(255,255,255,0.5)",
              textAlign: { xs: "center", sm: "left" },
            }}
          >
            © {currentYear} ThinkWay. Todos os direitos reservados.
          </Typography>

          {/* <Stack
            direction="row"
            alignItems="center"
            spacing={0.5}
            sx={{ color: "rgba(255,255,255,0.5)" }}
          >
            <Typography variant="body2">Feito com</Typography>
            <Favorite sx={{ fontSize: 16, color: "#EF443C" }} />
            <Typography variant="body2">no Brasil</Typography>
          </Stack> */}
        </Stack>
      </Container>
    </Box>
  );
};

export default FooterSection;
